import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { REACT_APP_NAV_ROUTES } from "../../../router/AppNavigation";


const UserOnboard = Loadable(
  lazy(() => import("./UserOnboard"))
);

export const userOnboardRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.userOnboard,
    element: <UserOnboard />,
  },
];
